/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_dnamw_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculate the molecular weight of a DNA or RNA sequence (ssDNA, dsDNA or ssRNA).`)
};

const es_dnamw_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcula el peso molecular de una secuencia de ADN o ARN (ADNss, ADNds o ARNss).`)
};

const de_dnamw_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Berechnen Sie das Molekulargewicht einer DNA- oder RNA-Sequenz (ssDNA, dsDNA oder ssRNA).`)
};

const nl_dnamw_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bereken het molecuulgewicht van een DNA- of RNA-sequentie (ssDNA, dsDNA of ssRNA).`)
};

const fr_dnamw_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculez la masse moléculaire d'une séquence d'ADN ou d'ARN (ADNsb, ADNdb ou ARNsb).`)
};

const it_dnamw_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcola il peso molecolare di una sequenza di DNA o RNA (ssDNA, dsDNA o ssRNA).`)
};

const pt_br2_dnamw_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcule o peso molecular de uma sequência de DNA ou RNA (ssDNA, dsDNA ou ssRNA).`)
};

const pt_dnamw_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcule a massa molecular de uma sequência de ADN ou ARN (ssADN, dsADN ou ssARN).`)
};

const ja_dnamw_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DNAまたはRNA配列（ssDNA、dsDNA、ssRNA）の分子量を計算します。`)
};

const zh_dnamw_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`计算 DNA 或 RNA 序列（ssDNA、dsDNA 或 ssRNA）的分子量。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const dnamw_tool_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.dnamw_tool_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("dnamw_tool_description", locale)
	if (locale === "en") return en_dnamw_tool_description(inputs)
	if (locale === "es") return es_dnamw_tool_description(inputs)
	if (locale === "de") return de_dnamw_tool_description(inputs)
	if (locale === "nl") return nl_dnamw_tool_description(inputs)
	if (locale === "fr") return fr_dnamw_tool_description(inputs)
	if (locale === "it") return it_dnamw_tool_description(inputs)
	if (locale === "pt-BR") return pt_br2_dnamw_tool_description(inputs)
	if (locale === "pt") return pt_dnamw_tool_description(inputs)
	if (locale === "ja") return ja_dnamw_tool_description(inputs)
	return zh_dnamw_tool_description(inputs)
};